export function set (name, value, expire, path = '/') {
  const now = new Date()
  const expireTime = now.getTime() + expire * 1000
  now.setTime(expireTime)
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${now.toUTCString()};path=${path};Secure`
}

export function get (name) {
  if (document.cookie.length > 0) {
    let nameStart = document.cookie.indexOf(name + '=')
    if (nameStart !== -1) {
      nameStart = nameStart + name.length + 1
      let nameEnd = document.cookie.indexOf(';', nameStart)
      if (nameEnd === -1) nameEnd = document.cookie.length
      return decodeURIComponent(document.cookie.substring(nameStart, nameEnd))
    }
  }
  return ''
}

export function del (name) {
  set(name, '', -1)
}

export default {
  set,
  get,
  del
}
